export default __webpack_public_path__ + "static/media/tier21.d51e4901.png";